var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M32.863,309.891v-4.259H3.918v4.259a6.386,6.386,0,0,0,6.171,6.592H38.652A6.42,6.42,0,0,1,32.863,309.891Z",
    transform: "translate(-3.918 -276.483)",
    fill: "#ece17f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M99.8,4.825,94.415,0,89.031,4.825,83.648,0,78.265,4.825,72.882.052v30.3h20.6v3.787A5.853,5.853,0,0,0,98.97,40h.362a5.907,5.907,0,0,0,4.141-1.712,5.808,5.808,0,0,0,1.708-4.15V.052Z",
    transform: "translate(-65.181)",
    fill: "#fff06f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(11.599 12.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M137.326,138.293h10.793a1.75,1.75,0,1,0,0-3.5H137.326a1.75,1.75,0,1,0,0,3.5Z",
    transform: "translate(-135.576 -134.793)",
    fill: "#343845"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M156.287,207.935h-18.96a1.75,1.75,0,0,0,0,3.5h18.96a1.75,1.75,0,0,0,0-3.5Z",
    transform: "translate(-135.576 -199.768)",
    fill: "#343845"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.cacf713444388d3bd1bc2cddc3f71cfc.svg";
export { ForwardRef as ReactComponent };